export function loadScriptOnce(src, { id, attrs } = {}) {
  if (id && document.getElementById(id)) return Promise.resolve()
  if (!id && document.querySelector(`script[src="${src}"]script`)) return Promise.resolve()

  return new Promise((resolve, reject) => {
    const s = document.createElement('script')
    if (id) s.id = id
    s.src = src
    s.async = true
    if (attrs) Object.keys(attrs).forEach(k => s.setAttribute(k, attrs[k]))
    s.onload = resolve
    s.onerror = () => reject(new Error(`Failed to load script: ${src}`))
    document.head.appendChild(s)
  })
}



// WEBPACK FOOTER //
// ./src/modules/shared/services/consent/loaders/script.js